import Gateway from '@/utils/Gateway';

let cacheData;

function handleRes(res, resolve) {
    const { code, data } = res || {};
    const {
        sync_status: syncStatus,
        sync_mode: syncMode,
        sync_rule_type: syncRuleType,
        sync_rule: syncRule,
        default_roles: defaultRoles,
        send_msg_by_tel: sendMsg,
        org_inited: orgInited,
        msg: resErrMsg
    } = data || {};

    let hasError = false;
    let hasSyncRule = true;
    let syncType = '';
    let isAllSameRole = false;
    let isSendMsg = false;
    let isOrgInited = false;
    let isImportIng = false;
    let errMsg = resErrMsg;
    let errType = '';

    // sync_status 同步状态 1-未开启 2-待初始化(前端开启使用) 3-同步进行中 4-已完成当次同步 5-异常
    if (syncStatus === 1) {
        hasSyncRule = false;
    } else if (syncStatus === 5) {
        hasError = true;
    }

    // sync_mode 同步模式 1-自动 2-手动
    if (syncMode === 1) {
        syncType = 'all';
    } else if (syncMode === 2) {
        syncType = 'some';
    }

    // 角色同步类型 1-所有员工使用相同角色 2-不同部门使用不同角色
    if (syncRuleType === 1) {
        isAllSameRole = true;

        if (!defaultRoles || defaultRoles.length <= 0) {
            hasError = true;
            errType = 'noAllRole';
            errMsg = '所有角色已都不存在，请重新选择角色';
        }
    } else if (syncRuleType === 2) {
        if (!defaultRoles || defaultRoles.length <= 0) {
            hasError = true;
            errType = 'noDefaultRole';
            errMsg = '默认角色已不存在，请重新选择默认角色';
        }
    }

    // 将密码发送到手机 1-否 2-是
    if (sendMsg === 2) {
        isSendMsg = true;
    }

    if (orgInited === 2) {
        isOrgInited = true;
    }

    // syncMode 为2  orgInited为1 -准备中
    // syncMode 为2  orgInited为2 syncStatus不是3和6 -能导入
    // syncMode 为2  orgInited为2 syncStatus是3或6 -导入中
    if (syncStatus === 3 || syncStatus === 6) {
        isImportIng = true;
    }

    if (code !== 0) {
        hasSyncRule = false;

        if (code === 40014) {
            hasError = true;
            errType = 'params';
        }
    }

    resolve({
        code,
        hasSyncRule,
        hasError,
        syncStatus,
        syncMode,
        syncType,
        syncRuleType,
        syncRule: syncRule || [],
        defaultRoles: defaultRoles || [],
        isAllSameRole,
        isSendMsg,
        isOrgInited,
        isImportIng,
        errMsg,
        errType
    });
}

// 企业微信通讯录同步配置获取
export default function getSyncConfig(config) {
    const { useCache } = config || {};
    return new Promise((resolve, reject) => {
        if (useCache && cacheData) {
            handleRes(cacheData, resolve);
        } else {
            Gateway.get('/v1/wework/GetSyncConfig', {}, { originRes: true })
                .then(res => {
                    handleRes(res, resolve);
                    cacheData = res;
                })
                .catch(e => {
                    const { code, message } = e || {};

                    if (code === 40014) {
                        handleRes(cacheData, resolve);
                    } else {
                        reject(message || '获取通讯录同步配置失败');
                    }
                });
        }
    });
}
